export enum TipoLayout {
  INSTITUCIONES = 'INSTITUCIONES',
  PROGRAMAS = 'PROGRAMAS',
}
